import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Sports = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="container mx-auto px-6 py-12">
            {/* Heading */}
            <h1 className="text-3xl font-bold text-center mb-6">SPORTS</h1>

            {/* Introduction */}
            <div className="w-full" data-aos="fade-up">
                <p className="text-lg text-gray-700 leading-relaxed text-center">
                    Our school encourages sports activities to promote physical fitness, teamwork, and discipline. We offer a variety of indoor and outdoor sports facilities to help students develop their athletic skills and maintain a healthy lifestyle.
                </p>
            </div>

            {/* Indoor Sports Section */}
            <div className="mt-12">
                <h2 className="text-2xl font-semibold text-center mb-4">Indoor Sports</h2>
                <p className="text-lg text-gray-700 leading-relaxed text-center">
                    Our indoor sports facilities provide a safe and engaging environment for students to participate in various games and activities.
                </p>

                {/* Image Grid for Indoor Sports */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-6" data-aos="fade-up">
                    <img src="https://img.freepik.com/free-photo/boy-setting-up-carroms-board_1353-85.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Indoor Badminton" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-photo/boy-setting-up-carroms-board_1353-85.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Table Tennis" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-photo/boy-setting-up-carroms-board_1353-85.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Chess" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-photo/boy-setting-up-carroms-board_1353-85.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Indoor Basketball" className="w-full h-48 object-cover rounded-lg shadow-md" />
                </div>
            </div>

            {/* Outdoor Sports Section */}
            <div className="mt-12">
                <h2 className="text-2xl font-semibold text-center mb-4">Outdoor Sports</h2>
                <p className="text-lg text-gray-700 leading-relaxed text-center">
                    Our outdoor sports facilities provide students with a space to enhance their athletic performance, teamwork, and sportsmanship.
                </p>

                {/* Image Grid for Outdoor Sports */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mt-6" data-aos="fade-up">
                    <img src="https://img.freepik.com/free-vector/kids-playing-red-light-green-light-game_1308-104503.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Football" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-vector/kids-playing-red-light-green-light-game_1308-104503.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Cricket" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-vector/kids-playing-red-light-green-light-game_1308-104503.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Athletics" className="w-full h-48 object-cover rounded-lg shadow-md" />
                    <img src="https://img.freepik.com/free-vector/kids-playing-red-light-green-light-game_1308-104503.jpg?ga=GA1.1.736731524.1738591350&semt=ais_hybrid" alt="Basketball" className="w-full h-48 object-cover rounded-lg shadow-md" />
                </div>
            </div>
        </div>
    );
};

export default Sports;
